export default __webpack_public_path__ + "static/media/add-to-apple-wallet.08a77a88.png";